// style
export const tileCols2 = (i: number) => i >= 0 && Math.floor(i / 2) % 2 === i % 2
export const tileCols2_inverted = (i: number) => i >= 0 && Math.floor(i / 2) % 2 !== i % 2
export const tileCols4 = (i: number) => i >= 0 && Math.floor(i / 4) + ((i % 4) % 2) === 1
export const tileCols5 = (i: number) => i >= 0 && (Math.floor(i / 5) + i) % 2 === 0
export const tileCols5_inverted = (i: number) => i >= 0 && (Math.floor(i / 5) + i) % 2 === 1

// Staff grouping utility
export function groupByJob<T extends { job?: string }>(items: T[]): Record<string, T[]> {
  return items.reduce(
    (acc: Record<string, T[]>, item: T) => {
      if (item.job) {
        const normalizedJob = item.job.replace(/[\u200B-\u200D\uFEFF]/g, '').trim()
        acc[normalizedJob] = acc[normalizedJob] || []
        acc[normalizedJob].push(item)
      }
      return acc
    },
    {} as Record<string, T[]>
  )
}

// Sort by job groups but keep as flat array - preserves sibling relationship for checkerboard patterns
export function sortByJobGroups<T extends { job?: string }>(items: T[]): T[] {
  // First group by job
  const grouped = groupByJob(items)

  // Then flatten back to array, maintaining job group order
  return Object.values(grouped).flat()
}

// Complex checkerboard pattern utilities
export function getComplexTileBackground(groupIndex: number, itemIndex: number): string {
  const isGroupEven = groupIndex % 2 === 0
  const isItemEven = itemIndex % 2 === 0

  if (isGroupEven && !isItemEven) return 'bg-system-tilebg'
  if (!isGroupEven && isItemEven) return 'bg-system-tilebg'
  return ''
}

export function getMobileComplexTileBackground(groupIndex: number, itemIndex: number): string {
  const isGroupEven = groupIndex % 2 === 0
  const remainder = itemIndex % 4

  if (isGroupEven && (remainder === 0 || remainder === 3)) return 'max-md:bg-system-tilebg'
  if (!isGroupEven && (remainder === 1 || remainder === 2)) return 'max-md:bg-system-tilebg'
  return 'max-md:bg-gray-100'
}
